
import { fetchSetJobStatusSplitToBase } from '@/helpers/fetchers';
import { Component, Prop, Vue } from 'vue-property-decorator';
import Button from '@/components/UI/Button.vue';
import Icon from '@/components/UI/Icon.vue';
import LookupWarehouses from '@/components/UI/LookupWarehouses.vue';
import { JobDetailedData } from '@/models/jobDetailed';
import { kktsSplitToBase } from '@/utils/PortalConstants';
import { JobAllocateParams } from '@/models/JobComplianceTypes';

@Component({
  components: {
    Button,
    Icon,
    LookupWarehouses,
  },
})
export default class SplitToBaseDialog extends Vue {
  @Prop(Boolean) public isOpen: boolean;
  @Prop(Object) public job!: JobDetailedData;

  public loading = false;
  public whChosen = '';
  public kktsSplitToBase = kktsSplitToBase;

  public whChanged(value: string): void {
    this.whChosen = value;
  }

  public setSplitToBase(): Promise<void> {
    this.loading = true;
    const params: JobAllocateParams = {
      action: 'tobase',
      job_id: this.job.rockhopper_id,
      job_date: this.job.rockhopper_date,
      driver: this.job.driver_code || 0,
      stop_number: 2,
      base: this.kktsSplitToBase.indexOf(this.whChosen) + 1 || 0,
    };

    return fetchSetJobStatusSplitToBase(params)
      .then(() => void this.$emit('fetchData'))
      .catch(() => void {})
      .finally(() => (this.loading = false));
  }
}
